import { DataSet } from './data-set.js'
import { DataSetMutation } from './data-set-mutation.js'
import { DataSetQuery } from './data-set-query.js'

export const entities = [DataSet]
export const resolvers = [DataSetQuery, DataSetMutation]
